/* eslint-disable */
import objectHasher from 'node-object-hash';

const { hash } = objectHasher();

/**
 * Generates a unique hash for the object
 * @param {any} object The object to hash
 * @returns {number} The offset in minutes
 */
const generateHash = (object) => {
  return hash(object);
};

export default generateHash;
